import { Button, Box, Typography, CircularProgress } from "@mui/material";

interface AccountSetupStepProps {
  loading: boolean;
  onCheckStatus: () => Promise<void>;
}

const AccountSetupStep = ({ loading, onCheckStatus }: AccountSetupStepProps) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2 }}>
      <Typography variant="body1">
        Finish your account setup to start accepting payments.
      </Typography>
      {loading ? (
        <CircularProgress />
      ) : (
        <Button
          variant="contained"
          color="primary"
          onClick={onCheckStatus}
          disabled={loading}
          size="large">
          Check Account Status
        </Button>
      )}
    </Box>
  );
};

export default AccountSetupStep; 